import React from "react";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";

import { Icons } from "../../../assets/icons";
import {
  COLORS,
  VIDEO_DURATION,
  RECAP_EVENT_FIELD,
  RECAP_FEEDBACK_ACTION,
} from "../../../constants";
import IconButton from "../IconButton/IconButton";
import CustomTooltip from "../ToolTip/CustomTooltip";
import SelectField from "../../components/Fields/SelectField";
import TimestampSelector from "../../components/Fields/TimestampSelector";

const { InfoIcon } = Icons;

const SingleRecapFeedback = (props) => {
  const { data, onChange, disabled = false } = props;

  const handleChange = (field, value) => {
    onChange(field, value);
  };

  const handleTimestampChange = (timeString) => {
    handleChange(RECAP_EVENT_FIELD.TIME_REQUESTED, timeString);
  };

  // Check if this is old data (actionType 1-4) or new data (actionType 5)
  const isOldData = data.actionType && data.actionType !== RECAP_FEEDBACK_ACTION.SIMPLE_FEEDBACK;

  // Old data UI (disabled)
  if (isOldData) {
    return (
      <>
        <div className="row align-items-center">
          <div className="col-10 col-sm-11">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4 m-0 pl-0">
                <div className="w-100">
                  <SelectField
                    options={[
                      { label: "add clip", value: RECAP_FEEDBACK_ACTION.ADD },
                      { label: "delete clip", value: RECAP_FEEDBACK_ACTION.DELETE },
                      { label: "change clip", value: RECAP_FEEDBACK_ACTION.CHANGE },
                      { label: "song feedback", value: RECAP_FEEDBACK_ACTION.SONG_FEEDBACK },
                    ]}
                    error={data?.errors?.actionType}
                    id="select-action"
                    label="select an action:"
                    placeholder="select an action:"
                    value={data.actionType}
                    setValue={(action) =>
                      handleChange(RECAP_EVENT_FIELD.ACTION_TYPE, action.value)
                    }
                    valueKey="value"
                    disabled={true}
                  />
                </div>
              </div>

              {!(data?.actionType === RECAP_FEEDBACK_ACTION.SONG_FEEDBACK) && (
                <div className="col-12 col-md-4 col-lg-4 m-0 pl-0">
                  <div className="w-100">
                    <TimestampSelector
                      onTimeSelect={handleTimestampChange}
                      videoDuration={VIDEO_DURATION.DEFAULT}
                      initialTime={data?.timeRequested}
                      error={data?.errors?.timeRequested}
                      disabled={true}
                      isShowTooltip={
                        data.actionType === RECAP_FEEDBACK_ACTION.ADD
                      }
                    />
                  </div>
                </div>
              )}

              {!(
                data?.actionType === RECAP_FEEDBACK_ACTION.DELETE ||
                data?.actionType === RECAP_FEEDBACK_ACTION.SONG_FEEDBACK
              ) && (
                <div className="col-12 col-md-4 col-lg-4 pl-0">
                  <AvForm className="file-name-field" autoComplete="off">
                    <AvField
                      type="text"
                      label={
                        <span className="bold-label">
                          file name:
                          <CustomTooltip
                            id={`tooltip1`}
                            title="please provide the filename of the video clip you wish us to add or change"
                            arrow
                            placement="right"
                            className="ml-2"
                          >
                            <span tabIndex="0">
                              <IconButton
                                icon={<InfoIcon />}
                                width="12px"
                                height="12px"
                              />
                            </span>
                          </CustomTooltip>
                        </span>
                      }
                      name="filename"
                      className="form-control w-100"
                      onChange={(e) =>
                        handleChange(RECAP_EVENT_FIELD.FILE_NAME, e.target.value)
                      }
                      value={data.filename}
                      disabled={true}
                    />
                    {data?.errors?.filename && (
                      <div className="invalid-field-error d-block">
                        {data.errors.filename}
                      </div>
                    )}
                  </AvForm>
                </div>
              )}

              {data?.actionType === RECAP_FEEDBACK_ACTION.SONG_FEEDBACK && (
                <div className="col-12 col-md-8 col-lg-8 pl-0">
                  <AvForm className="file-name-field" autoComplete="off">
                    <AvField
                      type="text"
                      label={<span className="bold-label">feedback:</span>}
                      name="feedback"
                      className="form-control w-100"
                      onChange={(e) =>
                        handleChange(RECAP_EVENT_FIELD.FEEDBACK, e.target.value)
                      }
                      value={data.feedback}
                      disabled={true}
                    />
                    {data?.errors?.feedback && (
                      <div className="invalid-field-error d-block">
                        {data.errors.feedback}
                      </div>
                    )}
                  </AvForm>
                </div>
              )}
            </div>
          </div>

          <div className="col-2 col-sm-1"></div>
        </div>
      </>
    );
  }

  // New data UI (SIMPLE_FEEDBACK only)
  return (
    <div>
      <label className="bold-label">feedback:</label>
      <textarea
        rows="6"
        className="form-control w-100"
        onChange={(e) =>
          handleChange(RECAP_EVENT_FIELD.FEEDBACK, e.target.value)
        }
        value={data.feedback}
        disabled={disabled}
      />
      {data?.errors?.feedback && (
        <div className="invalid-field-error d-block">
          {data.errors.feedback}
        </div>
      )}
    </div>
  );
};

export default SingleRecapFeedback;
